import { viewToCollabJSON } from '@databases/collab/convert/to-collab';
import { type DatabaseChangeType } from '@databases/types/redux';

import { type YJSChangeHandler } from '../../types';

export const addSavedView: YJSChangeHandler<DatabaseChangeType.ADD_SAVED_VIEW> = ({
  ydb,
  change
}) => {
  ydb.mutate((db) => {
    db.addView(change.view.id, viewToCollabJSON(change.view, {}));
  });
};
